// import React, { useState, useRef, useEffect } from "react";
// import { useReactFlow } from "reactflow";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSearch } from "@fortawesome/free-solid-svg-icons";


// export default function NodeSearch({ nodes }) {
//     const [query, setQuery] = useState("");
//     const [showList, setShowList] = useState(false);
//     const { setCenter } = useReactFlow();
//     const wrapperinputRef = useRef(null);

//     // Hide list when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (wrapperinputRef.current && !wrapperinputRef.current.contains(event.target)) {
//                 setShowList(false);
//             }
//         };

//         if (showList) {
//             document.addEventListener("pointerdown", handleClickOutside, true); // capture phase
//         }

//         return () => {
//             document.removeEventListener("pointerdown", handleClickOutside, true);
//         };
//     }, [showList]);


//     const handleSelect = (nodeId) => {
//         const node = nodes.find((n) => n.id === nodeId);
//         if (node) {
//             const { x, y } = node.position;
//             setCenter(x, y, { zoom: 1.5, duration: 800 });
//         }
//         setShowList(false);
//     };

//     const filteredNodes = nodes.filter((n) =>
//         n.data.title.toLowerCase().includes(query.toLowerCase())
//     );

//     return (
//         <div
//             className="test"
//             ref={wrapperinputRef}
//             style={{
//                 position: "relative",
//                 width: "240px",
//                 background: "#fff",
//                 borderRadius: "8px",
//                 fontFamily: "Inter, sans-serif",
//                 boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                 zIndex: "999"
//             }}
//         >
//             {/* Search Input */}
//             <div style={{ position: "relative", width: "100%" }}>
//                 <input
//                     type="text"
//                     placeholder="Search..."
//                     value={query}
//                     onChange={(e) => {
//                         setQuery(e.target.value);
//                         setShowList(true);
//                     }}
//                     onFocus={() => setShowList(true)}
//                     style={{
//                         width: "100%",
//                         border: "none",
//                         outline: "none",
//                         padding: "10px 36px 10px 12px", // extra space for icon
//                         fontSize: "14px",
//                         borderBottom: "1px solid #eee",
//                     }}
//                 />
//                 <FontAwesomeIcon
//                     icon={faSearch}
//                     style={{
//                         position: "absolute",
//                         right: "12px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         color: "#888",
//                         fontSize: "14px",
//                         pointerEvents: "none",
//                     }}
//                 />
//             </div>

//             {/* Scrollable List */}
//             {showList && (
//                 <div
//                     style={{
//                         maxHeight: "240px",
//                         overflowY: "auto",
//                         padding: "4px 0",
//                         borderRadius: "0 0 8px 8px",
//                         boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                         background: "#fff",
//                         position: "absolute",
//                         top: "42px",
//                         left: 0,
//                         right: 0,
//                         zIndex: 10,
//                     }}
//                 >
//                     {filteredNodes.length > 0 ? (
//                         filteredNodes.map((n) => (
//                             <div
//                                 key={n.id}
//                                 onClick={() => handleSelect(n.id)}
//                                 style={{
//                                     padding: "6px 12px",
//                                     cursor: "pointer",
//                                     transition: "background 0.2s",
//                                     color: "#000000ff",
//                                 }}
//                                 onMouseEnter={(e) =>
//                                     (e.currentTarget.style.background = "#e3e2e2ff")
//                                 }
//                                 onMouseLeave={(e) =>
//                                     (e.currentTarget.style.background = "transparent")
//                                 }
//                             >
//                                 {n.data.title}
//                             </div>
//                         ))
//                     ) : (
//                         <div
//                             style={{
//                                 padding: "6px 12px",
//                                 color: "#999",
//                                 fontSize: "13px",
//                             }}
//                         >
//                             No nodes found
//                         </div>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// }
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { useReactFlow } from "reactflow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default function NodeSearch({ nodes }) {
    const [query, setQuery] = useState("");
    const [showList, setShowList] = useState(false);
    const { setCenter } = useReactFlow();
    const wrapperRef = useRef(null);

    const filteredNodes = useMemo(() => {
        const lowerQuery = query.toLowerCase();
        return nodes.filter((n) =>
            n.data.title.toLowerCase().includes(lowerQuery)
        );
    }, [nodes, query]);

    // Hide list when clicking outside
    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowList(false);
        }
    }, []);

    useEffect(() => {
        if (showList) {
            document.addEventListener("pointerdown", handleClickOutside, true);
        }
        return () => {
            document.removeEventListener("pointerdown", handleClickOutside, true);
        };
    }, [showList, handleClickOutside]);

    const handleSelect = useCallback(
        (nodeId) => {
            const node = nodes.find((n) => n.id === nodeId);
            if (node) {
                const { x, y } = node.position;
                setCenter(x, y, { zoom: 1.5, duration: 800 });
            }
            setShowList(false);
        },
        [nodes, setCenter]
    );

    // --- Styles ---
    const styles = {
        wrapper: {
            position: "relative",
            width: 240,
            background: "#fff",
            borderRadius: 8,
            fontFamily: "Inter, sans-serif",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 999,
        },
        inputContainer: { position: "relative", width: "100%" },
        input: {
            width: "100%",
            border: "none",
            outline: "none",
            padding: "10px 36px 10px 12px",
            fontSize: 14,
            borderBottom: "1px solid #eee",
        },
        icon: {
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            color: "#888",
            fontSize: 14,
            pointerEvents: "none",
        },
        list: {
            maxHeight: 240,
            overflowY: "auto",
            padding: "4px 0",
            borderRadius: "0 0 8px 8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            background: "#fff",
            position: "absolute",
            top: 42,
            left: 0,
            right: 0,
            zIndex: 10,
        },
        listItem: {
            padding: "6px 12px",
            cursor: "pointer",
            transition: "background 0.2s",
            color: "#000",
        },
        noResult: {
            padding: "6px 12px",
            color: "#999",
            fontSize: 13,
        },
    };

    return (
        <div ref={wrapperRef} style={styles.wrapper}>
            {/* Search Input */}
            <div style={styles.inputContainer}>
                <input
                    type="text"
                    placeholder="Search..."
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setShowList(true);
                    }}
                    onFocus={() => setShowList(true)}
                    style={styles.input}
                />
                <FontAwesomeIcon icon={faSearch} style={styles.icon} />
            </div>

            {/* Dropdown List */}
            {showList && (
                <div style={styles.list}>
                    {filteredNodes.length > 0 ? (
                        filteredNodes.map((n) => (
                            <div
                                key={n.id}
                                onClick={() => handleSelect(n.id)}
                                style={styles.listItem}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.background = "#e3e2e2")
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = "transparent")
                                }
                            >
                                {n.data.title}
                            </div>
                        ))
                    ) : (
                        <div style={styles.noResult}>No nodes found</div>
                    )}
                </div>
            )}
        </div>
    );
}
